import { makeAutoObservable, runInAction } from "mobx";
import { StudentHttpRepository } from "./student_http_repository";
import { Student } from "./student_model";

export class StudentStore {
  repository = new StudentHttpRepository();
  students: Student[] = [];
  page = 0;
  busy = false;
  error = "";
  notice = "";
  editing: Student | null | undefined = undefined;
  username = "";
  password = "";

  constructor() { makeAutoObservable(this, {}, { autoBind: true }); }
  setUsername(value: string) { this.username = value; }
  setPassword(value: string) { this.password = value; }
  open(student: Student | null) {
    if (this.busy) return;
    this.editing = student;
    this.username = student?.username ?? "";
    this.password = "";
    this.error = "";
    this.notice = "";
  }
  close() {
    if (this.busy) return;
    this.editing = undefined;
    this.password = "";
    this.error = "";
  }
  async list(page = this.page) {
    if (this.busy) return;
    this.busy = true;
    this.error = "";
    const result = await this.repository.list(page);
    runInAction(() => {
      this.busy = false;
      if (result.isFailure()) this.error = result.error.message;
      else { this.students = result.value; this.page = page; }
    });
  }
  async save() {
    if (this.busy || this.editing === undefined) return;
    this.error = "";
    const username = this.username.trim();
    if (!/^[\p{L}\p{N}_.-]{3,64}$/u.test(username)) {
      this.error = "Логин: 3–64 символа, буквы, цифры, точка, дефис или подчёркивание.";
      return;
    }
    if ((!this.editing || this.password) && (this.password.length < 12 || this.password.length > 1024)) {
      this.error = "Пароль должен содержать от 12 до 1024 символов.";
      return;
    }
    this.busy = true;
    const created = !this.editing;
    const changedPassword = Boolean(this.password);
    const result = await this.repository.save({
      ...(this.editing ? { _id: this.editing._id } : {}), username,
      ...(this.password ? { password: this.password } : {}),
    });
    runInAction(() => {
      this.busy = false;
      if (result.isFailure()) this.error = result.error.message;
      else {
        this.password = "";
        this.editing = undefined;
        this.notice = created
          ? `Учётная запись «${username}» создана. Передайте ученику логин и заданный пароль лично.`
          : changedPassword ? "Пароль изменён. Прежние сессии завершены." : "Логин сохранён.";
      }
    });
    if (result.isSuccess()) await this.list(created ? 0 : this.page);
  }
  async setBlocked(student: Student) {
    if (this.busy) return false;
    this.busy = true;
    this.error = "";
    const result = await this.repository.save({
      _id: student._id, username: student.username, isBlocked: !student.isBlocked,
    });
    runInAction(() => {
      this.busy = false;
      if (result.isFailure()) this.error = result.error.message;
      else this.notice = student.isBlocked ? "Доступ восстановлен." : "Доступ заблокирован. Сессии ученика завершены.";
    });
    if (result.isSuccess()) await this.list();
    return result.isSuccess();
  }
}
